import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Product } from '../domain/product';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { buildUpdateInventoryCountPayload } from 'common/services/product-payload.util';
@Component({
  selector: 'app-update-stock-count',
  templateUrl: './update-stock-count.component.html',
  styleUrls: ['./update-stock-count.component.css']
})
export class UpdateStockCountComponent implements OnInit {
  loading: boolean = false;
  product: Product;
  user: IUser;
  products: any[];
  sourceProducts: any[];
  isData: boolean = false;
  first: number = 0;
  confirmationDialogVisible = false;
  private pendingConfirmationAction: (() => void) | null = null;
  imgPreview: boolean = false;
  imgPreviewImg: any;


  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Update-Products-Inventory' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("UpdateStockCountComponent", label);
  }
  ngOnInit(): void {
    this.products = [];
    this.product = new Product();
    this.user = AuthService.getLoggedInUser();
    this.isData = false;
    this.getProducts();
    this.imgPreviewImg = "";
  }

  getProducts() {
    this.loading = true;
    this.appServiceManager.get(`branches/${this.user.branch}/products`).subscribe((res: any) => {
      if (res.length > 0) {
        this.products = res;
        this.isData = true;
        this.products.map(x => {
          x["countedQunatity"] = x.totalQuantity
        })
        this.sourceProducts = res;
      } else {
        this.isData = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.isData = false;
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  onPageChange(event) {
    this.first = event.first;
  }

  openPhoto(imgUri) {
    this.imgPreview = true;
    this.imgPreviewImg = imgUri;
  }

  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  updateInventoryCount() {
    this.confirmationDialogVisible = true;
    this.pendingConfirmationAction = () => {
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        this.appServiceManager.post(
          `branches/${branchId}/products/actions/update-inventory-count`,
          buildUpdateInventoryCountPayload(this.products),
        ).subscribe((res: any) => {
          if (res?.status === false) {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: res.error || 'Something Went Wrong',
            });
            return;
          }
          if (res.status) {
            this.messageService.clear();
            this.getProducts();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Inventory Count Successfully Updated' });

          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
    };
  }

  cancelConfirmationDialog() {
    this.confirmationDialogVisible = false;
    this.pendingConfirmationAction = null;
  }

  confirmConfirmationDialog() {
    const action = this.pendingConfirmationAction;
    this.cancelConfirmationDialog();
    action?.();
  }

}
